import axios from "axios";

/** Global axios timeout for API requests. */
export const API_REQUEST_TIMEOUT_MS = 30000;

/** Longer timeout for file uploads. */
export const UPLOAD_REQUEST_TIMEOUT_MS = 60000;

/** Shared axios timeout for auth endpoints (cold starts / proxy latency). */
export const AUTH_REQUEST_TIMEOUT_MS = 15000;

export function configureAxiosDefaults() {
  axios.defaults.timeout = API_REQUEST_TIMEOUT_MS;
  axios.defaults.withCredentials = true;
}

export function authRequestErrorMessage(error) {
  if (error?.code === "ECONNABORTED") {
    return "Request timed out. The server may be waking up — try again.";
  }
  if (!error?.response) {
    return "Could not reach the server. Check your connection and try again.";
  }
  const detail = error.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  return error?.message || "Something went wrong. Try again.";
}
